export function chunkValues(values, size = 10) {
    const chunks = [];
    for (let index = 0; index < values.length; index += size) {
        chunks.push(values.slice(index, index + size));
    }
    return chunks;
}
export function timeValue(value) {
    if (value instanceof Date)
        return value.getTime();
    if (value &&
        typeof value === "object" &&
        "toDate" in value &&
        typeof value.toDate === "function") {
        return value.toDate().getTime();
    }
    if (typeof value === "string") {
        const parsed = Date.parse(value);
        return Number.isNaN(parsed) ? 0 : parsed;
    }
    if (typeof value === "number")
        return value;
    return 0;
}
export function formatDateTime(value) {
    const timestamp = timeValue(value);
    return timestamp ? new Date(timestamp).toLocaleString() : "-";
}
export function formatDuration(start, end) {
    const startTime = timeValue(start);
    const endTime = timeValue(end);
    if (!startTime || !endTime || endTime < startTime)
        return "-";
    const seconds = Math.round((endTime - startTime) / 1000);
    if (seconds < 60)
        return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    const remainder = seconds % 60;
    if (minutes < 60)
        return `${minutes}m ${remainder}s`;
    const hours = Math.floor(minutes / 60);
    return `${hours}h ${minutes % 60}m`;
}
export function stringifyPayload(value) {
    if (!value || Object.keys(value).length === 0)
        return "-";
    return JSON.stringify(value, null, 2);
}
export function taskLabel(task) {
    const contactName = typeof task.input.contactName === "string" ? task.input.contactName : "";
    const phoneNumber = typeof task.input.phoneNumber === "string" ? task.input.phoneNumber : "";
    if (contactName && phoneNumber)
        return `${contactName} (${phoneNumber})`;
    return contactName || phoneNumber || task.id || "Task";
}
export function runPlaybookName(run, playbook) {
    return playbook?.name || run.playbookSnapshot.name || run.playbookId;
}
export function terminalTaskCount(run) {
    return (run.taskCounts.completed + run.taskCounts.failed + run.taskCounts.cancelled);
}
export function runProgressLabel(run) {
    return `${terminalTaskCount(run)}/${run.taskCounts.total} terminal`;
}
export function runSuccessRate(run) {
    const terminal = terminalTaskCount(run);
    if (!terminal)
        return "-";
    return `${Math.round((run.taskCounts.completed / terminal) * 100)}%`;
}
export function groupTasksByRunId(tasks) {
    const grouped = new Map();
    for (const task of tasks) {
        const list = grouped.get(task.playbookRunId) || [];
        list.push(task);
        grouped.set(task.playbookRunId, list);
    }
    for (const list of grouped.values()) {
        list.sort((a, b) => timeValue(a.createdAt) - timeValue(b.createdAt));
    }
    return grouped;
}
export function groupAttemptsByTaskId(attempts) {
    const grouped = new Map();
    for (const attempt of attempts) {
        const list = grouped.get(attempt.taskId) || [];
        list.push(attempt);
        grouped.set(attempt.taskId, list);
    }
    for (const list of grouped.values()) {
        list.sort((a, b) => b.attemptNumber - a.attemptNumber);
    }
    return grouped;
}
